import { WorkflowStepsBaseService } from "app/core/workflow/workflow-steps/workflow-steps-base.service";
import { AdditionalOptionsComponentPath } from "app/core/workflow/page-path/statement-page-path/additional-options-component.path";

type PremiumIncomeType = "real_estate" | "capital_income";

export class WorkflowAdditionalOptionsSubBaseService extends WorkflowStepsBaseService {
  public get subStepNumber(): number {
    return 2;
  }

  public get isRequired(): boolean {
    return !this.isBusiness || this.isTaxAdviser;
  }

  public get isDone(): boolean {
    const currentType = this.getSelectedPremiumIncomeTypeForPosition(this.subStepNumber - 2);
    const premiumIncomeGroups = Array.isArray((this.statement as any)?.premiumIncome)
      ? (this.statement as any).premiumIncome
      : [];

    if (!currentType) {
      return true;
    }

    return premiumIncomeGroups.some((group) => group?.income_type === currentType);
  }

  public get isVisible(): boolean {
    return (
      this.isRequired &&
      window.location.href.search(AdditionalOptionsComponentPath.regex()) !== -1 &&
      this.getSelectedPremiumIncomeTypes().length >= this.subStepNumber - 1
    );
  }

  public get title(): string {
    return this.getPremiumIncomeTitleKey(
      this.getSelectedPremiumIncomeTypeForPosition(this.subStepNumber - 2) ||
        this.getSelectedPremiumIncomeTypes()[0] ||
        "real_estate"
    );
  }

  public get checkCanGo(): boolean {
    return !this.blockedDefaultWorkflow
      && this.statement
      && this.isRequired
      && (!!this.statement.stageAdditionalIncome || !!this.statement.stageSteuerAdditionalOption)
      && this.getSelectedPremiumIncomeTypes().length >= this.subStepNumber - 1;
  }

  public get urlRegex(): RegExp {
    return AdditionalOptionsComponentPath.regex(this.subStepNumber);
  }

  public get url(): string {
    return AdditionalOptionsComponentPath.url(this.getStatementId, this.subStepNumber);
  }

  public get isSubStep(): boolean {
    return true;
  }

  protected getSelectedPremiumIncomeTypes(): PremiumIncomeType[] {
    const selectedTypes: PremiumIncomeType[] = [];
    const premiumIncomeGroups = Array.isArray((this.statement as any)?.premiumIncome) ? (this.statement as any).premiumIncome : [];

    if (this.statement?.hasRentalIncome || premiumIncomeGroups.some((group) => group?.income_type === "real_estate")) {
      selectedTypes.push("real_estate");
    }

    if (this.statement?.hasCapitalIncome || premiumIncomeGroups.some((group) => group?.income_type === "capital_income")) {
      selectedTypes.push("capital_income");
    }

    return selectedTypes;
  }

  protected getSelectedPremiumIncomeTypeForPosition(position: number): PremiumIncomeType | null {
    return this.getSelectedPremiumIncomeTypes()[position] || null;
  }

  protected getPremiumIncomeTitleKey(type: PremiumIncomeType): string {
    return type === "real_estate"
      ? "ASIDE_BAR.PREMIUM_INCOME_SUBLIST.REAL_ESTATE"
      : "ASIDE_BAR.PREMIUM_INCOME_SUBLIST.CAPITAL_INCOME";
  }
}
